import { Col, Row } from "react-bootstrap";
import {
  SiVisualstudiocode,
  SiPostman,
  SiMacos,
  SiLinux,
  SiOpenai,
  SiSupabase,
  SiCouchbase,
} from "react-icons/si";

function Toolstack() {
  const tools = [
    { icon: <SiMacos />, name: "macOS" },
    { icon: <SiVisualstudiocode />, name: "VS Code" },
    { icon: <SiSupabase />, name: "Supabase" },
    { icon: <SiOpenai />, name: "OpenAI" },
    { icon: <SiLinux />, name: "Linux" },
    { icon: <SiPostman />, name: "Postman" },
    { icon: <SiCouchbase />, name: "Couchbase" },
  ];

  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {tools.map((t, i) => (
        <Col key={i} xs={4} md={2} className="tech-icons tooltip">
          {t.icon}
          <span className="tooltip-text">{t.name}</span>
        </Col>
      ))}
    </Row>
  );
}

export default Toolstack;
